// TR-442 / BFS #7: dirty-tracking helpers for the Language tab Contextual Save Bar.
// Extracted from index.tsx so the reset-vs-keep decision is unit-testable and the
// magic-number condition (`Object.entries(language.fieldsChange).length < 4`) no
// longer hides the intent.

// Keys that come from the languageConfig object — distinct from the per-section
// translation keys (`trackingStatus`, `trackingForm`, …) that `handleChange` adds.
export const LANGUAGE_TOP_LEVEL_CONFIG_KEYS = [
  'language',
  'googleTranslateExtension',
  'googleTranslatePosition',
] as const;

type ConfigKey = (typeof LANGUAGE_TOP_LEVEL_CONFIG_KEYS)[number];

/**
 * Returns true when `fieldsChange` contains a non-config key whose value is not
 * undefined — i.e., the user has already dirtied a translation section. Used by
 * the Save Bar trigger so toggling a config field with no other edits still
 * resets cleanly to `{}` when the config flips back to its original value.
 */
export const hasOtherDirtyFields = (fieldsChange: object): boolean =>
  Object.entries(fieldsChange).some(
    ([key, value]) => !LANGUAGE_TOP_LEVEL_CONFIG_KEYS.includes(key as ConfigKey) && value !== undefined,
  );
